module.exports = __webpack_public_path__ + "static/media/Kopp.0d56f76d.PNG";